module.exports = "<div class=\"wrapper wrapper-content animated fadeIn\" id=import> <div class=row> <div class=col-lg-12> <div class=ibox> <div class=ibox-content> <h2>Instructions</h2> <div class=row> <ul> </ul> </div> <h2>What has already been uploaded?</h2> <crud-file-compact-list></crud-file-compact-list> </div> </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// .-dna/app/subsections/grant-and-import/import.version-control-system.html
// module id = 4174
// module chunks = 86